// extracted by mini-css-extract-plugin
module.exports = {"getStartedBtn":"MainButtonStyle_getStartedBtn__3meK6","getStartedBtnIcon":"MainButtonStyle_getStartedBtnIcon__2vVRt"};